/**
 * Sigorta / Kasko tarih kuralları (28.10.2026, Burak kararı, #501 / #502) — sunucudaki SigortaPoliceHesap ile aynı.
 * Tarihler poliçedeki gibi girilir: 01.01.2026 - 01.01.2027. Hesaplar gün bazında (yyyy-MM-dd), saat etkisizdir.
 */

export const BELGE_TURU = { TRAFIK: 1, KASKO: 2 };
export const POLICE_DURUMU = { BASLAMADI: 1, DEVAM_EDIYOR: 2, SURESI_DOLDU: 3 };
export const BITIS_UYARISI = { NORMAL: 0, YAKLASIYOR: 1, DOLDU: 2 };
export const YAKLASIYOR_GUN = 30;

const parca = (_tarih: string) => _tarih.split('-').map(Number);

const utc = (_tarih: string) => {
    const [y, a, g] = parca(_tarih);
    return Date.UTC(y, a - 1, g);
}

const yaz = (_y: number, _a: number, _g: number) => `${_y}-${String(_a).padStart(2, '0')}-${String(_g).padStart(2, '0')}`;

export const gecerliTarih = (_tarih: string | undefined | null): _tarih is string => !!_tarih && /^\d{4}-\d{2}-\d{2}$/.test(_tarih);

/** Bugün (yerel saat) yyyy-MM-dd. */
export const bugunStr = (_simdi: Date = new Date()) => yaz(_simdi.getFullYear(), _simdi.getMonth() + 1, _simdi.getDate());

/** Bir takvim yılı sonrası; 29.02 artık olmayan yılda 28.02 olur (365 gün eklenmez). */
export const bitisOnerisi = (_baslangic: string): string => {
    const [y, a, g] = parca(_baslangic);
    const ayinSonGunu = new Date(Date.UTC(y + 1, a, 0)).getUTCDate();
    return yaz(y + 1, a, Math.min(g, ayinSonGunu));
}

/** Yenileme (kopyalama): yeni poliçe eski bitiş günü başlar, bitiş bir yıl sonrası önerilir. */
export const yenilemeTarihleri = (_eskiBitis: string) => ({ baslangic: _eskiBitis, bitis: bitisOnerisi(_eskiBitis) });

/** Bitiş − bugün (gün); bitiş günü 0. */
export const kalanGun = (_bitis: string, _bugun: string) => Math.round((utc(_bitis) - utc(_bugun)) / 86400000);

export const sureGun = (_baslangic: string, _bitis: string) => Math.round((utc(_bitis) - utc(_baslangic)) / 86400000);

export const durum = (_baslangic: string, _bitis: string, _bugun: string): number =>
    _bugun < _baslangic ? POLICE_DURUMU.BASLAMADI : _bugun <= _bitis ? POLICE_DURUMU.DEVAM_EDIYOR : POLICE_DURUMU.SURESI_DOLDU;

export const DURUM_ADLARI: Record<number, string> = {
    [POLICE_DURUMU.BASLAMADI]: 'Başlamadı',
    [POLICE_DURUMU.DEVAM_EDIYOR]: 'Devam Ediyor',
    [POLICE_DURUMU.SURESI_DOLDU]: 'Süresi Doldu',
};

/** Başlamamış poliçede (gelecekteki yenileme) "yaklaşıyor" uyarısı verilmez. */
export const uyari = (_baslangic: string, _bitis: string, _bugun: string): number => {
    const kalan = kalanGun(_bitis, _bugun);
    if (kalan < 0)
        return BITIS_UYARISI.DOLDU;
    if (durum(_baslangic, _bitis, _bugun) == POLICE_DURUMU.BASLAMADI)
        return BITIS_UYARISI.NORMAL;
    return kalan <= YAKLASIYOR_GUN ? BITIS_UYARISI.YAKLASIYOR : BITIS_UYARISI.NORMAL;
}

export const uyariAdi = (_uyari: number, _kalan: number) =>
    _uyari == BITIS_UYARISI.DOLDU ? 'Süresi Doldu' : _uyari == BITIS_UYARISI.YAKLASIYOR ? (_kalan == 0 ? 'Bugün bitiyor' : 'Yaklaşıyor') : 'Normal';

/** Durum rozeti rengi (Metronic badge-light-*). */
export const durumRozeti = (_durum: number) =>
    _durum == POLICE_DURUMU.DEVAM_EDIYOR ? 'badge-light-success' : _durum == POLICE_DURUMU.BASLAMADI ? 'badge-light-info' : 'badge-light-danger';

/** Kalan gün rozeti rengi. */
export const uyariRozeti = (_uyari: number) =>
    _uyari == BITIS_UYARISI.DOLDU ? 'badge-light-danger' : _uyari == BITIS_UYARISI.YAKLASIYOR ? 'badge-light-warning' : 'badge-light-success';

/** dd.MM.yyyy */
export const tarihGoster = (_tarih: string | undefined) => {
    if (!gecerliTarih(_tarih))
        return '';
    const [y, a, g] = _tarih.split('-');
    return `${g}.${a}.${y}`;
}

/** Poliçe evrakı: PDF / JPG / PNG, en fazla 10 MB (sunucu da denetler). */
export const DOSYA_UZANTILARI = ['.pdf', '.jpg', '.jpeg', '.png'];
export const AZAMI_DOSYA_MB = 10;

export const dosyaHatasi = (_ad: string, _boyut: number): string | undefined => {
    const nokta = _ad.lastIndexOf('.');
    const uzanti = nokta >= 0 ? _ad.slice(nokta).toLowerCase() : '';
    if (!DOSYA_UZANTILARI.includes(uzanti))
        return `${_ad}: yalnız PDF, JPG ya da PNG yüklenebilir.`;
    if (_boyut <= 0)
        return `${_ad}: dosya boş.`;
    if (_boyut > AZAMI_DOSYA_MB * 1024 * 1024)
        return `${_ad}: dosya ${AZAMI_DOSYA_MB} MB'tan büyük olamaz.`;
    return undefined;
}
